import { render, staticRenderFns } from "./cleaner.vue?vue&type=template&id=0cf1efb4&scoped=true&"
import script from "./cleaner.vue?vue&type=script&lang=js&"
export * from "./cleaner.vue?vue&type=script&lang=js&"
import style0 from "./cleaner.css?vue&type=style&index=0&id=0cf1efb4&prod&scoped=true&lang=css&"
import style1 from "./cleaner.vue?vue&type=style&index=1&id=0cf1efb4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf1efb4",
  null
  
)

export default component.exports